export const DELETE_ITEM_REQUEST = 'DELETE_ITEM_REQUEST';
export const DELETE_ITEM_SUCCESS = 'DELETE_ITEM_SUCCESS';
export const DELETE_ITEM_FAILURE = 'DELETE_ITEM_FAILURE';

// Action creators based on action types

export function deleteItemRequest() {
  return { type: DELETE_ITEM_REQUEST };
}

export function deleteItemSuccess() {
  return { type: DELETE_ITEM_SUCCESS };
}

export function deleteItemFailure(error) {
  return { type: DELETE_ITEM_FAILURE, payload: error };
}

